import type { SVGProps } from 'react'

export type TextIconName = 'bold' | 'underline' | 'italic' | 'left' | 'center' | 'right' | 'top' | 'middle' | 'bottom' | 'up' | 'down' | 'reset' | 'diamond' | 'previous' | 'next' | 'none'

/** Original vector geometry matching the reference controls; no font-glyph icons. */
export function TextIcon({ name, ...props }: SVGProps<SVGSVGElement> & { name: TextIconName }) {
  const paths: Record<TextIconName, string> = {
    bold: 'M6 3h5a4 4 0 0 1 0 8H6m0-8v16h6a4 4 0 0 0 0-8H6',
    underline: 'M6 3v7a5 5 0 0 0 10 0V3M4 19h14',
    italic: 'M10 3h8M4 19h8M14 3 8 19',
    left: 'M3 4h16M3 8h10M3 12h16M3 16h10',
    center: 'M3 4h16M6 8h10M3 12h16M6 16h10',
    right: 'M3 4h16M9 8h10M3 12h16M9 16h10',
    top: 'M4 3v16M8 3v10M12 3v16M16 3v10',
    middle: 'M4 3v16M8 6v10M12 3v16M16 6v10',
    bottom: 'M4 3v16M8 9v10M12 3v16M16 9v10',
    up: 'm7 13 4-4 4 4', down: 'm7 9 4 4 4-4',
    reset: 'M5 8a7 7 0 1 1-1 6M5 3v5H0',
    diamond: 'm11 3 7 8-7 8-7-8 7-8',
    previous: 'm13 6-5 5 5 5', next: 'm9 6 5 5-5 5',
    none: 'M4 4 18 18M21 11a10 10 0 1 1-20 0 10 10 0 0 1 20 0',
  }
  return <svg width="20" height="20" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth={name === 'bold' ? 2.6 : 1.6} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}><path d={paths[name]} /></svg>
}
